import { Text, Title3 } from "@fluentui/react-components";
import {
  DISTRIBUTION_LOCKED_MESSAGE,
  DISTRIBUTION_LOCKED_TITLE,
} from "apps/diagnostics/common/constants";
import { WarningIcon } from "../icons/WarningIcon";
import { useStyles } from "../externalDiagnosticsInvalidUrl/externalDiagnosticsInvalidUrl.styles";

export const ExternalDiagnosticLockedDistribution = (): JSX.Element => {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.warningCircle}>
          <WarningIcon />
        </div>

        <Title3 className={styles.title}>{DISTRIBUTION_LOCKED_TITLE}</Title3>

        <Text role="alert" className={styles.messageContent}>
          {DISTRIBUTION_LOCKED_MESSAGE}
        </Text>
      </div>
    </div>
  );
};
